export default {
  title: 'Important notes',
  buttons: {
    add_note: 'Add note',
  },
};
